import List from './list';
import Status from './status';

let routes = [];
routes = routes.concat({ path: 'list', exact: true, name: 'basic', component: <List /> });
routes = routes.concat({ path: 'status', exact: true, name: 'basic', component: <Status /> });

export default routes;
